/**
 * Presentation-only gate for profile and post Message actions.
 * Same rules as the DM bridge canOfferDirectMessage helper.
 * Server authorization remains authoritative for conversation create.
 *
 * @param {{ actor: { id: () => string|number }|null|undefined, targetUser: { id: () => string|number }|null|undefined, canMessage: boolean }} args
 * @returns {boolean}
 */
export default function canOfferMessageAction(_ref) {
  let {
    actor,
    targetUser,
    canMessage
  } = _ref;
  if (!actor || !targetUser) {
    return false;
  }
  if (!canMessage) {
    return false;
  }
  if (typeof targetUser.id !== 'function' || typeof actor.id !== 'function') {
    return false;
  }
  return targetUser.id() !== actor.id();
}
flarum.reg.add('flatrate-messaging-ui', 'forum/utils/canOfferMessageAction', canOfferMessageAction);